axios.defaults.withCredentials = true; //让ajax携带cookie
axios.defaults.timeout = 30000;

import axios from 'axios';
import { Toast, Indicator } from 'mint-ui';

// create an axios instance
const service = axios.create({
    baseURL: window.location.origin + '/api/', // api的base_url
    withCredentials: true,
    timeout: 30000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        if (config && config.data && config.data.noLoadingIcon) {
            // 接口参数传noLoadingIcon=true, 不转圈圈
            return config;
        }
        Indicator.open();
        return config;
    },
    error => {
        Indicator.close();
        Promise.reject(error);
    }
);

service.interceptors.response.use(
    response => {
        Indicator.close();
        return response.data;
    },
    error => {
        Indicator.close();
        !error.config.noErrMsg && Toast('系统错误');
        return Promise.reject(error);
    }
);

export default function sendRequest({ method, url, noErrMsg, params }) {
    let appos = 1,
        appid = 10080003,
        appversion = (window.PPDWebUI && window.PPDWebUI.os.buildVersion) || '6.8.0';
    if (window.PPDWebUI && window.PPDWebUI.os.inApp && window.PPDWebUI.os.android) {
        appos = 2;
        appid = 10080004;
    } else { 
        if (window.__wxjs_environment === 'miniprogram' && getCookie('miniappPlatform')) {
            let miniappPlatform = getCookie('miniappPlatform');
            if (miniappPlatform == 'android') { 
                appos = 2;
            }
        }
        var isTTWebView = navigator.userAgent.toLowerCase().includes("toutiaomicroapp");
        if (isTTWebView && getCookie('miniappPlatform')) {
            let miniappPlatform = getCookie('miniappPlatform');
            if (miniappPlatform == 'android') { 
                appos = 2;
            }
        }
    }
    window.PPDWebUI && window.PPDWebUI.os.inApp;
    let obj = {
        method,
        url,
        noErrMsg,
        params
    };
    if (method === 'post') {
        obj = {
            url,
            method,
            noErrMsg,
            data: params,
            headers: {
                'X-PPD-APPOS': appos,
                'X-PPD-APPID': appid,
                'X-PPD-APPVERSION': appversion,
                'X-PPD-TIMESTAMP': parseInt(new Date().getTime() / 1000)
            }
        };
    } else if (method === 'get') {
        obj = {
            url,
            method,
            noErrMsg,
            params: params,
            headers: {
                'X-PPD-APPOS': appos,
                'X-PPD-APPID': appid,
                'X-PPD-APPVERSION': appversion,
                'X-PPD-TIMESTAMP': parseInt(new Date().getTime() / 1000)
            }
        };
    }
    return service(obj);
}
